module.exports = __webpack_public_path__ + "static/media/208-Arzt_ID_18.c76e5d1f.mp3";